import React from 'react';
import { string, func } from 'prop-types';

import { Button, Icon } from './styles';

function ButtonModal({
  icon,
  iconLight,
  width,
  label,
  type,
  onClick,
  align,
  height,
  margin,
}) {
  return (
    <Button
      width={width}
      type={type}
      onClick={onClick}
      align={align}
      height={height}
      margin={margin}
    >
      {icon !== null && <Icon src={icon} iconLight={iconLight} />} {label}
    </Button>
  );
}

export default ButtonModal;

ButtonModal.propTypes = {
  width: string,
  height: string,
  label: string.isRequired,
  type: string,
  margin: string,
  onClick: func,
  icon: string,
  align: string,
};

ButtonModal.defaultProps = {
  width: null,
  icon: null,
  height: null,
  margin: 0,
  align: null,
  type: 'primary',
  onClick: () => {},
};
